export const SupportedDownloadGames = [
  'MEGA888',
  'PUSSY888',
  'XE88',
  'ACE333',
  '918KISS',
  '918KAYA',
  'ALIBABA',
  'SUNCITY2',
  'GW99',
];
